import { render, staticRenderFns } from "./ApplicationRenameOverlay.vue?vue&type=template&id=40264b7f&scoped=true"
import script from "./ApplicationRenameOverlay.vue?vue&type=script&lang=js"
export * from "./ApplicationRenameOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40264b7f",
  null
  
)

export default component.exports